import { Reducer } from 'redux'

import { fetchIntegration } from 'common/actions/integrations/common/actions/integrationActions'

export const integrationsLoadersReducer: Reducer<Record<string, boolean>> = (
  state = {},
  action,
) => {
  switch (action.type) {
    case fetchIntegration.pending.type: {
      const integrationType = action.meta.arg
      return { ...state, [integrationType]: true }
    }
    case fetchIntegration.fulfilled.type: {
      const integrationType = action.meta.arg
      return { ...state, [integrationType]: false }
    }
    default:
      return state
  }
}
